// eslint-disable-next-line
export default {
   'program.export': 'Exportar',
   'program.date': 'Fecha',
   'program.planName': 'Plan de lealtad',
   'program.id': 'ID',
}
